import { render, staticRenderFns } from "./pondLabTestsTab.vue?vue&type=template&id=3bd22fed&"
import script from "./pondLabTestsTab.vue?vue&type=script&lang=js&"
export * from "./pondLabTestsTab.vue?vue&type=script&lang=js&"
import style0 from "./pondLabTestsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports